<div class="div_loading">
  <div class="my-container" [hidden]="!loading">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
</div>
<div class="row dflex" style="display: flex !important;">
  <div class="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-xs-12 padding0">
    <input class="search_box" name="search_all" [(ngModel)]="search_all" (keyup)="check_access(4,1,'',1,2)"
      placeholder="{{ messageService.get_search() }}" autocomplete="off" style="width:100%">
  </div>
  <div class="col-xl-8 col-lg-8 col-md-7 col-sm-8 col-xs-12 padding0">
    <div class="service_pager">
      <span>
        <div class="video_div1" (click)="open_video()" *ngIf="video">
          <mat-icon class="video">smart_display</mat-icon>
        </div>
        <button (click)='open_dialog_fund()' *ngIf="level == 2" class="hidden-xs">
          موجودی اولیه صندوق
        </button>
        <button class="search1" (click)='open_detaile(0,3,0)'>
          <span>
            گزارش موجوی صندوق
          </span>
        </button>
        <div class="pager_pe">
          <button (click)="check_access(4,2,0,1,1)" [disabled]='next_status'><i class="fas fa-forward"></i></button>
          <button (click)="check_access(4,3,0,1,1)" [disabled]='pre_status'><i class="fas fa-backward"></i></button>
        </div>
        <div class='navigation'><span> {{ page_number_first }}
          </span><span>-</span><span> {{ page_number_second }} </span><span> of </span><span>
            {{ count_total }} </span>
        </div>
      </span>
    </div>
  </div>
  <div class="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-xs-12 padding0 hidden-sm hidden-xs">
    <div class="pager_checkbox">
      <div class="pager_icon_en">
        <div class="excel">
          <img src="../../../../../assets/images/excel.png" class="excel_icon cursor" (click)="load_data(1,2,1,-1)">
          <a href="" id="excel"><i class="far fa-file-excel" [hidden]="true"></i></a>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="content-body control-content-body" (window:resize)="change_resize()">
  <mat-table [dataSource]="dataSource" class='table-scroll mat_table_fa_without_scroll_bg pe1'>

    <ng-container matColumnDef="row">
      <mat-header-cell *matHeaderCellDef style='max-width:45px'>
        <span>#</span>
      </mat-header-cell>
      <mat-cell *matCellDef="let x;let i = index" style='max-width:45px'>{{ i +
        page_number_first }}</mat-cell>
      <mat-footer-cell *matFooterCellDef style='max-width:45px'></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="date">
      <mat-header-cell *matHeaderCellDef style="text-align: center !important;" style="max-width:120px">
        <span>تاریخ سند</span>
      </mat-header-cell>
      <mat-cell *matCellDef="let x;let i = index" style="max-width:120px"
        (click)="order_ref(x.id2,x.ref,x.finance_financial_document)">
        {{ x.date }}
      </mat-cell>
      <mat-footer-cell *matFooterCellDef style='max-width:120px'></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="service">
      <mat-header-cell *matHeaderCellDef style="text-align: center !important;" style="max-width:100px">
        <span>سرویس</span>
      </mat-header-cell>
      <mat-cell *matCellDef="let x;let i = index" style="max-width:100px"
        (click)="order_ref(x.id2,x.ref,x.finance_financial_document)">
        {{ x.ref_text }}
      </mat-cell>
      <mat-footer-cell *matFooterCellDef style='max-width:100px'></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="document">
      <mat-header-cell *matHeaderCellDef style="min-width:440px">
        <span>شرح</span>
      </mat-header-cell>
      <mat-cell *matCellDef="let x;let i = index" style="min-width:440px"
        (click)="order_ref(x.id2,x.ref,x.finance_financial_document)">
        <div class="right">
          <span>
            {{ x.alias }}
            <span>براساس سند شماره</span>
            <span> {{
              x.id2 }}</span>
          </span>
        </div>
      </mat-cell>
      <mat-footer-cell *matFooterCellDef style='min-width:440px'></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="user">
      <mat-header-cell *matHeaderCellDef style="min-width: 250px;">
        <span>نام طرف حساب / هزینه / درآمد</span>
      </mat-header-cell>
      <mat-cell *matCellDef="let x;let i = index" style="min-width: 250px;"
        (click)="order_ref(x.id2,x.ref,x.finance_financial_document)">
        <div class="right">{{ x.title }}</div>
      </mat-cell>
      <mat-footer-cell *matFooterCellDef style="min-width: 250px;"></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="bed">
      <mat-header-cell *matHeaderCellDef>
        <span>بدهکار</span>
      </mat-header-cell>
      <mat-cell *matCellDef="let x;let i = index" (click)="order_ref(x.id2,x.ref,x.finance_financial_document)">
        <div class="right">{{x.bed | number }}</div>
      </mat-cell>
      <mat-footer-cell *matFooterCellDef>
        <div class="right">{{ bed | number }}</div>
      </mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="best">
      <mat-header-cell *matHeaderCellDef>
        <span>بستانکار</span>
      </mat-header-cell>
      <mat-cell *matCellDef="let x;let i = index" (click)="order_ref(x.id2,x.ref,x.finance_financial_document)">
        <div class="right">
          {{x.best | number }}</div>
      </mat-cell>
      <mat-footer-cell *matFooterCellDef>
        <div class="right">{{ best | number }}</div>
      </mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="remain">
      <mat-header-cell *matHeaderCellDef>
        <span>مانده</span>
      </mat-header-cell>
      <mat-cell *matCellDef="let x;let i = index" (click)="order_ref(x.id2,x.ref,x.finance_financial_document)">
        <div class="money">{{ x.remain2 | number }}</div>
      </mat-cell>
      <mat-footer-cell *matFooterCellDef>
        <div class="footer1 money">{{ balance | number }}</div>
      </mat-footer-cell>
    </ng-container>

    <mat-header-row class="mat-header-row-dialog" *matHeaderRowDef="displayedColumns" color="primary">
    </mat-header-row>
    <mat-row class="mat-header-row-dialog" *matRowDef="let row;columns:displayedColumns;let i = index"
      (click)="mat_table_selectedRow = row" (mouseenter)="mat_table_hoverRow = row"
      [ngClass]="{'mat_table_selected': row === mat_table_selectedRow,mat_table_selected2:row.checked == true,'mat_table_hover': row === mat_table_hoverRow}"
      class="cursor"></mat-row>
    <mat-footer-row style="background: rgb(245 245 163) !important;bottom:-2px"
      *matFooterRowDef="displayedColumns;sticky : true">
    </mat-footer-row>
  </mat-table>

  <div class="row" class="preview1" [hidden]="count_total > 0">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <div>
        <img src="../../../assets//images/preview.png">
      </div>
      <div class="preview2">{{ messageService.get_no_record_text() }}</div>
    </div>
  </div>
</div>


<ngx-smart-modal #myModal identifier="myModal" class="pe" (onClose)="ModalClose()">
  <form #form_myModal="ngForm">
    <div class="dialog_title1">
      <span>{{ messageService.get_title(type_task) }}</span>
    </div>
    <div class="row">
      <div class='col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 pe'>
        <label for="title" class='wh-label'>
          <span> موجودی ابتدایی </span>
          <input class='wh-input' [(ngModel)]="fund" name="fund" autocomplete="off" currencyMask required>
        </label>
      </div>
    </div>
    <div class="row">
      <div class='col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12' style='margin-top:5px;text-align:center'>
        <button class="btn_pe" [disabled]="!form_myModal.valid" (click)="update_fund()">
          <span>ذخیره</span>
        </button>
      </div>
    </div>
  </form>
</ngx-smart-modal>